export const PostsPageView = 'posts';
